import { Toggle as PepsiCoDsToggle } from 'pepsico-ds'
import './toggleButtonStyles.scss'
import { SIZE, ORIENTATION } from '@/utils/constants/globalStyle'

/**
 * Toggle component renders a toggle switch with customizable properties.
 *
 * @param {Object} props - The properties object.
 * @param {boolean} props.value - The current value of the toggle.
 * @param {function} props.updateValue - The function to call when the toggle value changes.
 * @param {Object} props.uiSchema - The UI schema object containing additional properties.
 * @param {boolean} props.disabled - Flag to disable the toggle.
 * @param {function} [props.onToggleUpdate] - Optional callback function to call on toggle update.
 * @param {string} [props.id=''] - Optional additional id to apply to the toggle.
 *
 * @property {('small'|'medium')} [uiSchema.size=SIZE?.MEDIUM] - The size of the toggle.
 * @property {string} [uiSchema.className] - Additional class names for the toggle.
 * @property {boolean} [uiSchema.isDark=true] - Flag to set the toggle to dark mode.
 * @property {string} [uiSchema.defaultValue] - The default value of the toggle.
 * @property {string} [uiSchema.label] - The label for the toggle.
 * @property {string} [uiSchema.variant='horizontal'] - The variant of the toggle.
 *
 * @returns {JSX.Element} The rendered Toggle component.
 */
export default function Toggle({ value, updateValue, uiSchema, disabled, id }) {
  const {
    size = SIZE?.MEDIUM,
    className,
    isDark = true,
    // defaultValue,
    label,
    variant = ORIENTATION.HORIZONTAL,
    showCheckedIcon = true
  } = uiSchema

  return (
    <div className='toggle-btn'>
      <PepsiCoDsToggle
        data-testid={`toggle` + (id ? `_${id}` : '')}
        id={`toggle` + (id ? `_${id}` : '')}
        label={label}
        onUpdate={updateValue}
        size={size}
        checked={value}
        value={value ? 'Yes' : 'No'}
        disabled={disabled}
        className={className}
        isDark={isDark}
        variant={variant}
        showCheckedIcon={showCheckedIcon}
      />
    </div>
  )
}
